export default {
    ADD_INVITE_INFO: "setInviteInfo",
    ADD_INVITE_ERROR: 'setInviteError',

    //experiment
    ADD_EXPERIMENT_INFO: 'setExperimentInfo',

    //agreement
    ADD_AGREEMENT_ERROR: 'setAgreementError',

    //verify
    ADD_VERIFY_INFO: 'setVerifyInfo',
    ADD_VERIFY_ERROR: 'setVerifyError',
}
